export { default as IconLeaderboards } from './IconLeaderboards';
export { default as IconLearning } from './IconLearning';
export { default as IconRecycling } from './IconRecycling';
export { default as IconStart } from './IconStart';



// WEBPACK FOOTER //
// ./src/components/SVG/Navbar/index.js